function strCenter(source, charMax) {
  if(!source) return ' '
  let spaces = charMax - (source?.length || 0)
  let padLeft = spaces / 2 + (source?.length || 0)
  return source.padStart(padLeft, ' ')
}

function strRight(source, charMax) {
  if(!source) return ' '
  let spaces = charMax - (source?.length || 0)
  let padLeft = spaces + (source?.length || 0)
  return source.padStart(padLeft, ' ')
}

function strLeftRight(left, right, charMax) {
  if(!right) return (left || ' ')
  return (left + right.padStart(charMax - (left?.length || 0), ' '))
}

function wordWrap(str, charMax) {
  let arr = []
  let space = /\s/
  const words = str?.split(space)
  // push first word into new array
  if (words[0]?.length) {
    arr.push(words[0])
  }
  for (let i = 1; i < (words?.length || 0); i++) {
    if (words[i]?.length + arr[arr.length - 1]?.length < charMax) {
      arr[arr.length - 1] = `${arr[arr.length - 1]} ${words[i]}`
    } else {
      arr.push(words[i])
    }
  }
  return arr
}

const hunToEng = {
  'í': 'i',
  'Í': 'I',
  'é': 'e',
  'É': 'E',
  'á': 'a',
  'Á': 'A',
  'ű': 'u',
  'Ű': 'U',
  'Ü': 'U',
  'ü': 'u',
  'ö': 'o',
  'Ö': 'O',
  'ó': 'o',
  'Ó': 'O',
  'ő': 'o',
  'Ő': 'O'
}

function replaceHungarianChars(str) {
  let result = ''
  for (let letter of str) {
    result += (hunToEng[letter] || letter)
  }
  return result
}

export {
  wordWrap,
  strCenter,
  strRight,
  strLeftRight,
  replaceHungarianChars
}
